"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunalAreas = function CommunalAreas(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("g", {
    clipPath: "url(#clip0)"
  }, _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    d: "M13 15.5H11C10.8674 15.5 10.7402 15.5527 10.6464 15.6464C10.5527 15.7402 10.5 15.8674 10.5 16C10.5 16.1326 10.5527 16.2598 10.6464 16.3536C10.7402 16.4473 10.8674 16.5 11 16.5H13C13.1326 16.5 13.2598 16.4473 13.3536 16.3536C13.4473 16.2598 13.5 16.1326 13.5 16C13.5 15.8674 13.4473 15.7402 13.3536 15.6464C13.2598 15.5527 13.1326 15.5 13 15.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M21 15.5H19C18.8674 15.5 18.7402 15.5527 18.6464 15.6464C18.5527 15.7402 18.5 15.8674 18.5 16C18.5 16.1326 18.5527 16.2598 18.6464 16.3536C18.7402 16.4473 18.8674 16.5 19 16.5H21C21.1326 16.5 21.2598 16.4473 21.3536 16.3536C21.4473 16.2598 21.5 16.1326 21.5 16C21.5 15.8674 21.4473 15.7402 21.3536 15.6464C21.2598 15.5527 21.1326 15.5 21 15.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M23.5 9C23.5 8.86739 23.4473 8.74021 23.3536 8.64645C23.2598 8.55268 23.1326 8.5 23 8.5H17C16.8674 8.5 16.7402 8.55268 16.6464 8.64645C16.5527 8.74021 16.5 8.86739 16.5 9V20.5286H15.5V9C15.5 8.86739 15.4473 8.74021 15.3536 8.64645C15.2598 8.55268 15.1326 8.5 15 8.5H9C8.86739 8.5 8.74021 8.55268 8.64645 8.64645C8.55268 8.74021 8.5 8.86739 8.5 9V20.5286H7.5V9C7.5 8.86739 7.44732 8.74021 7.35355 8.64645C7.25979 8.55268 7.13261 8.5 7 8.5H1C0.867392 8.5 0.740215 8.55268 0.646447 8.64645C0.552678 8.74021 0.5 8.86739 0.5 9V20.5286H0V21.5286H24V20.5286H23.5V9ZM17.5 9.5H22.5V20.5286H17.5V9.5ZM9.5 9.5H14.5V20.5286H9.5V9.5ZM1.5 9.5H6.5V20.5286H1.5V9.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M5 15.5H3C2.86739 15.5 2.74021 15.5527 2.64645 15.6464C2.55268 15.7402 2.5 15.8674 2.5 16C2.5 16.1326 2.55268 16.2598 2.64645 16.3536C2.74021 16.4473 2.86739 16.5 3 16.5H5C5.13261 16.5 5.25979 16.4473 5.35355 16.3536C5.44732 16.2598 5.5 16.1326 5.5 16C5.5 15.8674 5.44732 15.7402 5.35355 15.6464C5.25979 15.5527 5.13261 15.5 5 15.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M0 2.5V3.5H7.5V5C7.5 5.13261 7.55268 5.25979 7.64645 5.35355C7.74021 5.44732 7.86739 5.5 8 5.5H16C16.1326 5.5 16.2598 5.44732 16.3536 5.35355C16.4473 5.25979 16.5 5.13261 16.5 5V3.5H24V2.5H0ZM15.5 4.5H8.5V3.5H15.5V4.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M5.5 13C5.77614 13 6 12.7761 6 12.5C6 12.2239 5.77614 12 5.5 12C5.22386 12 5 12.2239 5 12.5C5 12.7761 5.22386 13 5.5 13Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M13.5 13C13.7761 13 14 12.7761 14 12.5C14 12.2239 13.7761 12 13.5 12C13.2239 12 13 12.2239 13 12.5C13 12.7761 13.2239 13 13.5 13Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M21.6666 13C21.9428 13 22.1666 12.7761 22.1666 12.5C22.1666 12.2239 21.9428 12 21.6666 12C21.3905 12 21.1666 12.2239 21.1666 12.5C21.1666 12.7761 21.3905 13 21.6666 13Z",
    fill: props.foregroundColor
  })), _react.default.createElement("defs", null, _react.default.createElement("clipPath", {
    id: "clip0"
  }, _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};

CommunalAreas.defaultProps = {
  altText: "Communal Areas",
  backgroundColor: "#00D2D2",
  foregroundColor: "#000000"
};
CommunalAreas.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = CommunalAreas;
exports.default = _default;